import { z } from 'zod';
/**
 * Chat-Contracts (07 – Datenmodell / 03 – FA). 1:1 (direct) und Gruppen inkl.
 * „Familie"-Gruppe. Gelesen-Status über conversation_members.last_read_at →
 * Ungelesen-Badges. Nachrichten Soft-Delete.
 */
export const CONVERSATION_TYPES = ['direct', 'group'];
/** Anhang-Metadaten (Datei-Sharing, ADR-050). Download über /api/messages/:id/attachment. */
export const messageAttachmentSchema = z.object({
    name: z.string(),
    mime: z.string(),
    size: z.number().int(), // Bytes
});
export const messageDtoSchema = z.object({
    id: z.string().uuid(),
    conversationId: z.string().uuid(),
    senderId: z.string().uuid().nullable(),
    body: z.string().nullable(), // null = gelöscht
    attachment: messageAttachmentSchema.nullable(), // null = kein Anhang / gelöscht
    createdAt: z.string(),
    editedAt: z.string().nullable(),
    deletedAt: z.string().nullable(),
});
export const conversationDtoSchema = z.object({
    id: z.string().uuid(),
    type: z.enum(CONVERSATION_TYPES),
    name: z.string().nullable(),
    memberIds: z.array(z.string().uuid()),
    createdBy: z.string().uuid().nullable(), // null = System-Gruppe „Familie" (nicht verwaltbar)
    lastMessage: z
        .object({ senderId: z.string().uuid().nullable(), body: z.string().nullable(), createdAt: z.string() })
        .nullable(),
    unreadCount: z.number().int(),
    lastActivityAt: z.string(),
});
/** Gruppe umbenennen (nur Gruppen; nicht die System-„Familie"). */
export const updateConversationSchema = z.object({
    name: z.string().min(1).max(80),
});
/** Mitglieder zu einer Gruppe hinzufügen. */
export const addMembersSchema = z.object({
    memberIds: z.array(z.string().uuid()).min(1).max(50),
});
export const createConversationSchema = z.object({
    type: z.enum(CONVERSATION_TYPES),
    memberIds: z.array(z.string().uuid()).min(1).max(50),
    name: z.string().min(1).max(80).optional(),
});
export const createMessageSchema = z.object({
    body: z.string().min(1).max(4000),
});
//# sourceMappingURL=chat.js.map